import React from "react";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Card = ({ name, feedback, date }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <div
      className="card p-3 bg-light shadow-sm border border-3 text-start  rounded-4"
      style={{ maxHeight: "390px", minHeight: "280px" }}
    >
      <div className="  py-2 px-1  d-flex flex-column justify-content-between align-items-start">
        <div className="   d-flex justify-content-between align-items-center flex-row gap-3">
          <h4 className="tag text-center py-2  fw-bold"> {name}</h4>
          <h6 style={{ fontSize: "12px" }}> {formatDate(date)}</h6>
        </div>
      </div>
      <span
        className="d-flex justify-content-btween -p-1"
        style={{ color: "#ee0" }}
      >
        <FontAwesomeIcon className="px-1" icon={faStar} />
        <FontAwesomeIcon className="px-1" icon={faStar} />
        <FontAwesomeIcon className="px-1" icon={faStar} />
        <FontAwesomeIcon className="px-1" icon={faStar} />
        <FontAwesomeIcon className="px-1" icon={faStar} />
      </span>

      <p className="text-lead mt-4">{feedback}</p>
    </div>
  );
};

export default Card;
